import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useOptionHasDiscount } from "@hooks/useOptionHasDiscount.hook";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { DA_ButtonLink } from "@danishagro/shared/src/components/atoms/ButtonLink/ButtonLink.component";
import { DA_CartButton } from "@molecules/CartButton/CartButton.component";
import { DA_ContentBox } from "@danishagro/shared/src/components/atoms/ContentBox/ContentBox.component";
import { DA_DeliveryInfoModalContent } from "@templates/DeliveryInfoModal/DeliveryInfoModal.component";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_ImageSlider } from "@molecules/ImageSlider/ImageSlider.component";
import { DA_PriceTableLine } from "@molecules/PriceTable/PriceTable.component";
import { DA_QuantityPicker } from "@molecules/QuantityPicker/QuantityPicker.component";
import { DA_StockStatus } from "@atoms/StockStatus/StockStatus.component";
import { DA_Tab } from "@danishagro/shared/src/components/molecules/Tab/Tab.component";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_WishListButton } from "@molecules/WishListButtonSiloAndHouse/WishListButton.component";
import { ModalSize, useModal } from "@danishagro/shared/src/contexts/modal.context";
import { useHidePrice } from "@hooks/useHidePrice.hook";
import { useCart } from "@danishagro/shared/src/contexts/cart/cart.context";
import { useScreen } from "@danishagro/shared/src/contexts/screen.context";
import { DA_Accordion } from "@danishagro/shared/src/components/molecules/Accordion/Accordion.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { useDynamicOverlay } from "@danishagro/shared/src/hooks/dynamicOverlay/useDynamicOverlay.hook";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import {
    DA_NewProduct,
    DA_NewVariantEntity,
} from "@danishagro/shared/src/interfaces/productv2.interface";
import { DA_InputWrapper } from "@danishagro/shared/src/components/atoms/InputWrapper/InputWrapper.component";
import { DA_Select } from "@danishagro/shared/src/components/atoms/Select/Select.component";
import { useNavigate } from "react-router-dom";
import { DA_Image } from "@danishagro/shared/src/components/atoms/Image/Image.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DA_InlineLink } from "@danishagro/shared/src/components/atoms/InlineLink/InlineLink.component";
import { useRelewise } from "@danishagro/shared/src/contexts/relewise.context";
import { DA_Tooltip } from "@danishagro/shared/src/components/atoms/Tooltip/Tooltip.component";
import { DA_Price } from "@atoms/Price/Price.component";
import { pushToDataLayer } from "@danishagro/shared/src/gtm/useTagManger";
import { formatNumber } from "@danishagro/shared/src/helpers/formatNumber.helper";
import { useProductTracker } from "@danishagro/shared/src/gtm/useProductsTracker";
import { usePage } from "@danishagro/shared/src/contexts/page.context";
import { DA_Tag } from "@danishagro/shared/src/components/atoms/Tag/Tag.component";
import { isGreaterThanZero } from "@danishagro/shared/src/helpers/greaterThanZero.helper";
import { DA_QuantityOnPalletOverlay } from "@danishagro/shared/src/modals/QuantityOnPalletShop/Overlay/Overlay.component";
import { useBottomSheet } from "@danishagro/shared/src/contexts/bottomSheet/bottomSheet.context";
import { DA_Modal } from "@danishagro/shared/src/components/molecules/Modal/Modal.component";
import { modalState } from "@danishagro/shared/src/enums/modalState.enum";
// import {
//     ProblemDetailsError,
//     ProductResult,
//     ProductsViewedAfterViewingProductBuilder,
// } from "@relewise/client";
// import ComponentErrorBoundary from "@danishagro/shared/src/components/molecules/ErrorBoundary/ComponentErrorBoundary.component";
// import { DA_ProductItemSlider } from "@organisms/ProductItemSlider";
import { useFavoriteList } from "@danishagro/shared/src/hooks/api/useFavoriteList.hook";
import { useFavorites } from "@danishagro/shared/src/contexts/favorites.context";
import { DA_Toast } from "@danishagro/shared/src/components/molecules/Toast/Toast.component";
import { getRelativeRootOnLocalhost } from "@danishagro/shared/src/helpers/getRelativeUrlOnLocalhost.helper";
import { B2B_SITE_ORIGIN } from "@danishagro/shared/src/constants/urlRoot.constants";
import toast from "react-hot-toast";
import { DA_Countdown } from "@molecules/Countdown/Countdown.component";
import Skeleton from "react-loading-skeleton";
import { BottomSheetDeliveryInfo } from "@organisms/BottomSheetDeliveryInfo";
import { DiscountTable } from "@organisms/DiscountTable";
import { StockAmountStatus } from "@atoms/StockAmountStatus/StockAmountStatus.component";
import { DA_SelectOption } from "@danishagro/shared/src/components/atoms/Select/Select.props";
import { useVariantPrices } from "@danishagro/shared/src/hooks/useVariantPrices.hook";
import { getPageByUrl } from "@helpers/getPage.helper";
import {
    DA_ProductPrice,
    QuantityDiscount,
} from "@danishagro/shared/src/interfaces/price.interface";
import { useMaxValue } from "@hooks/useMaxValue.hook";
import { useDeliveryPointSelectHandlers } from "@hooks/useDeliveryPointSelectHandlers.hook";
import { Helmet } from "react-helmet";
import { B2bImageSrc } from "@danishagro/shared/src/helpers/imageSrc.helper";
import { ImageConfig } from "@danishagro/shared/src/content/imageConfigs/imageConfig.enum";
import {
    useDeliveryPointsApi,
    DA_DeliveryAddress,
    DA_DeliveryPoint,
} from "@danishagro/shared/src/hooks/api/useDeliveryPointsApi.hook";
import { DA_Address } from "@danishagro/shared/src/interfaces/address.interface";
import Select, { components, MenuProps } from "react-select";
import { getSelectStyles } from "@danishagro/shared/src/helpers/getSelectStyles.helper";
import { DA_DropdownArrow } from "@danishagro/shared/src/components/atoms/DropdownArrow/DropdownArrow.component";
import { DA_ProductDescription } from "./components/ProductDescription/ProductDescription.component";
import { useShortDescription } from "./components/hooks/useShortDescription.hook";
import { BottomSheetSelect } from "./components/BottomSheetSelect/BottomSheetSelect.component";
import { useProductDeliveryAddresses } from "./hooks/useProductDeliveryAddresses.hook";
import { MobileDeliveryAddressSelect } from "./components/MobileDeliveryAddressSelect/MobileDeliveryAddressSelect.component";
import { MobileDeliveryPointSelect } from "./components/MobileDeliveryPointSelect/MobileDeliveryPointSelect.component";
// Import react-select components for custom Menu
import S from "./ProductDetailsV1.module.scss";

export interface V1Props extends DA_NewProduct {
    priceLines?: DA_PriceTableLine[];
    stockStatus?: string;
    isQuickOrder?: boolean;
    onVariantChange?: (variantEntity: DA_NewVariantEntity) => void;
}

interface DA_TabRefInterface {
    showDescriptionTab: () => void;
}
interface DA_ProductDescriptionRefInterface {
    showFullDescription: () => void;
    scrollIntoView: () => void;
}

export const V1 = (props: V1Props) => {
    const [quantity, setQuantity] = useState(1);
    const { isFarmInTimeEnabled, showPrices, displayFavoritesList } = useAppData();
    const [awaitingResponse, setAwaitingResponse] = useState(false);
    const [noProduct, _setNoProduct] = useState(false);
    const { customerNumber, currentCulture } = useAppData();
    const { getDictionaryString, getDictionaryItem } = useTranslations();
    const { addToCart } = useCart();
    const { showOverlay, closeOverlay } = useDynamicOverlay();
    const { showModal } = useModal();
    const hidePrice = useHidePrice();
    const { getProductVariantPrice } = useVariantPrices();
    const { getTracker, relewiseUser, allowTracking } = useRelewise();
    const { currentPathDetails } = usePage();
    const { isMobileOrTablet } = useScreen();
    const { presentBottomSheet } = useBottomSheet();
    const deliveryPointHandlers = useDeliveryPointSelectHandlers();
    const startOnVideos = useRef(location.hash.replace(/#/, "") === "video").current;
    const tabRef = useRef<DA_TabRefInterface>();
    const productDescriptionRef = useRef<DA_ProductDescriptionRefInterface>();
    const [quantityOnPalletValue, setQuantityOnPalletValue] = useState("");
    const [price, setPrice] = useState<DA_ProductPrice>();
    const [_salesEndDate, setSalesEndDate] = useState<string>(
        props.price?.quantityDiscounts[0]?.discount?.productDiscountEndDate as string
    );
    const [showDiscount, setShowDiscount] = useState<boolean>(false);
    const { siteVariant } = useAppData();
    const highMax = useMaxValue(siteVariant);
    const variantGroupsLength = props.variantGroups?.length || 0;
    const [variantsComplete, setVariantsComplete] = useState(true);
    const [choosedValue, setChoosedValue] = useState(false);
    const [modalViewState, setModalViewState] = useState<modalState>(modalState.hide);
    const [numberOfPallets, setNumberOfPallets] = useState<number>(0);
    const [totalPalletQuantity, setTotalPalletQuantity] = useState<number>(0);
    // const [relatedProducts, setRelatedProducts] = useState<ProductResult[] | null | undefined>();
    const favoritesListUrl = `${getRelativeRootOnLocalhost(B2B_SITE_ORIGIN)}/favorites`;

    // Delivery points state
    const { getDeliveryPoints } = useDeliveryPointsApi();
    const [deliveryAddresses, setDeliveryAddresses] = useState<DA_DeliveryAddress[]>([]);
    const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState<string>("");
    const [selectedDeliveryPoint, setSelectedDeliveryPoint] = useState<string>("");
    const [deliveryPointsLoading, setDeliveryPointsLoading] = useState(false);

    // Address management state for checkout integration
    const [checkoutAddresses, setCheckoutAddresses] = useState<DA_Address[]>([]);

    // Delivery address management (specialized for product delivery)
    const { onAddNewAddressClicked } = useProductDeliveryAddresses(setCheckoutAddresses);

    // Session storage key for delivery selections (product-specific)
    const deliveryStorageKey = `delivery-selection-${props.entityId}`;
    const variantSwitchFlagKey = `variant-switch-${props.entityId}`;

    // Utility functions for delivery selection persistence
    const saveDeliverySelection = useCallback(() => {
        if (selectedDeliveryAddress && selectedDeliveryPoint) {
            const selectionData = {
                address: selectedDeliveryAddress,
                point: selectedDeliveryPoint,
                timestamp: Date.now(),
            };
            sessionStorage.setItem(deliveryStorageKey, JSON.stringify(selectionData));
        }
    }, [selectedDeliveryAddress, selectedDeliveryPoint, deliveryStorageKey]);

    const restoreDeliverySelection = useCallback(() => {
        try {
            const savedData = sessionStorage.getItem(deliveryStorageKey);
            if (savedData) {
                const { address, point, timestamp } = JSON.parse(savedData);
                // Only restore if saved within last 30 seconds (variant switch window)
                const isRecent = Date.now() - timestamp < 30000;
                const wasVariantSwitch = sessionStorage.getItem(variantSwitchFlagKey) === "true";

                if (isRecent && wasVariantSwitch) {
                    return { address, point };
                }
            }
        } catch (error) {
            console.warn("Failed to restore delivery selection:", error);
        }
        return null;
    }, [deliveryStorageKey, variantSwitchFlagKey]);

    const clearDeliverySelection = useCallback(() => {
        sessionStorage.removeItem(deliveryStorageKey);
        sessionStorage.removeItem(variantSwitchFlagKey);
    }, [deliveryStorageKey, variantSwitchFlagKey]);

    // Custom Menu component for delivery address dropdown with "Add manual address" option
    const DeliveryAddressMenu = (props: MenuProps<DA_SelectOption>) => {
        return (
            <components.Menu {...props}>
                <React.Fragment>
                    {props.children}
                    <hr style={{ margin: 0, borderColor: "var(--color-grey-20)" }} />
                    <div
                        className={S.manualAddressOption}
                        role="button"
                        tabIndex={0}
                        onClick={() => handleManualAddressSelection()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleManualAddressSelection();
                            }
                        }}
                        onTouchEnd={() => handleManualAddressSelection()}
                    >
                        {getDictionaryString("siloAndHouses.addManualAddress")}
                    </div>
                </React.Fragment>
            </components.Menu>
        );
    };

    // Handle manual address selection
    const handleManualAddressSelection = () => {
        // Use the specialized address form for delivery addresses
        onAddNewAddressClicked();
    };

    // Sync checkout addresses with delivery addresses when they change
    useEffect(() => {
        if (checkoutAddresses.length > 0) {
            // Convert DA_Address[] to DA_DeliveryAddress[] for our delivery system
            const convertedAddresses: DA_DeliveryAddress[] = checkoutAddresses.map((address) => ({
                id: address.id,
                locationId: address.locationId,
                streetName: address.streetName,
                streetNumber: address.streetNumber,
                zipCode: address.zipCode,
                city: address.city,
                countryCode: address.countryCode,
                isPrimary: false,
                description: address.description || address.name,
                deliveryPoints: [],
            }));

            // Find new addresses (not already in deliveryAddresses)
            setDeliveryAddresses((prevDeliveryAddresses) => {
                const newAddresses = convertedAddresses.filter(
                    (converted) =>
                        !prevDeliveryAddresses.some((existing) => existing.id === converted.id)
                );

                if (newAddresses.length > 0) {
                    // Auto-select the most recently added address
                    const newestAddress = newAddresses[newAddresses.length - 1];
                    setSelectedDeliveryAddress(newestAddress.id);

                    // Reset delivery point to default when changing address
                    setSelectedDeliveryPoint("standard-delivery-point");

                    return [...prevDeliveryAddresses, ...newAddresses];
                }

                return prevDeliveryAddresses;
            });
        }
    }, [checkoutAddresses]);

    // Custom DA_Select component specifically for delivery addresses with custom Menu
    const DeliveryAddressSelect: React.FC<{
        options: DA_SelectOption[];
        value: string;
        onChange: (option: DA_SelectOption) => void;
        placeholder?: string;
        isDisabled?: boolean;
        id?: string;
        fullWidth?: boolean;
    }> = ({ options, value, onChange, fullWidth = true, ...props }) => {
        const { isMobile } = useScreen();
        const [isOpen, setIsOpen] = useState(false);

        return (
            <div className={`${fullWidth ? "w-full" : ""}`}>
                <Select<DA_SelectOption>
                    {...props}
                    options={options}
                    value={options.find((option) => option.value === value) || null}
                    onChange={(selectedOption) => selectedOption && onChange(selectedOption)}
                    components={{
                        Menu: DeliveryAddressMenu,
                        DropdownIndicator: (data) => <DA_DropdownArrow {...data} />,
                        IndicatorSeparator: () => null,
                    }}
                    styles={getSelectStyles({
                        isMobile: isMobile,
                        isGrouped: false,
                    })}
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    menuIsOpen={isOpen}
                    onMenuOpen={() => {
                        setIsOpen(true);

                        // Scroll to selected option after menu opens
                        setTimeout(() => {
                            // Try multiple selectors since menu is in portal
                            const menuList =
                                (document.querySelector('[class*="MenuList"]') as HTMLElement) ||
                                (document.querySelector('[class*="menu-list"]') as HTMLElement) ||
                                (document.querySelector(
                                    '.css-26l3qy-menu [class*="MenuList"]'
                                ) as HTMLElement);

                            const selectedElement =
                                (document.querySelector(
                                    '[class*="option--is-selected"]'
                                ) as HTMLElement) ||
                                (document.querySelector('[aria-selected="true"]') as HTMLElement);

                            if (menuList && selectedElement) {
                                // Calculate scroll position to center the selected item
                                const scrollTop =
                                    selectedElement.offsetTop -
                                    menuList.clientHeight / 2 +
                                    selectedElement.clientHeight / 2;
                                menuList.scrollTop = Math.max(0, scrollTop);
                            }
                        }, 100);
                    }}
                    onMenuClose={() => setIsOpen(false)}
                    isSearchable={true}
                />
            </div>
        );
    };

    // Fetch delivery points on component mount
    useEffect(() => {
        const fetchDeliveryPoints = async () => {
            if (!customerNumber || !props.masterProductNumber) return;

            setDeliveryPointsLoading(true);
            try {
                const response = await getDeliveryPoints(
                    customerNumber,
                    null,
                    props.masterProductNumber
                );
                if (response && Array.isArray(response)) {
                    setDeliveryAddresses(response);

                    // Try to restore saved delivery selection first
                    const savedSelection = restoreDeliverySelection();

                    if (
                        savedSelection &&
                        response.find((addr) => addr.id === savedSelection.address)
                    ) {
                        // Restore saved selection if address still exists
                        setSelectedDeliveryAddress(savedSelection.address);
                        setSelectedDeliveryPoint(savedSelection.point);
                        // Clear the variant switch flag after successful restore
                        sessionStorage.removeItem(variantSwitchFlagKey);
                    } else {
                        // Count total delivery points across all addresses
                        const allDeliveryPoints = response.flatMap(
                            (addr) => addr.deliveryPoints || []
                        );

                        if (allDeliveryPoints.length === 1) {
                            // Exactly 1 delivery point across all addresses — set its address and itself as default
                            const addressWithPoint = response.find(
                                (addr) =>
                                    addr.deliveryPoints &&
                                    addr.deliveryPoints.some(
                                        (dp) => dp.id === allDeliveryPoints[0].id
                                    )
                            );
                            if (addressWithPoint) {
                                setSelectedDeliveryAddress(addressWithPoint.id);
                                setSelectedDeliveryPoint(allDeliveryPoints[0].id);
                            }
                        } else {
                            // More than 1 delivery point (or none) — auto-select primary address but no default delivery point
                            const primaryAddress = response.find((addr) => addr.isPrimary);
                            const defaultAddress = primaryAddress || response[0];

                            if (defaultAddress) {
                                setSelectedDeliveryAddress(defaultAddress.id);
                                // Do not pre-select a delivery point when there are multiple options
                                if (allDeliveryPoints.length === 0) {
                                    setSelectedDeliveryPoint("standard-delivery-point");
                                }
                            }
                        }
                        // Clear any stale saved data
                        clearDeliverySelection();
                    }
                }
            } catch (error) {
                console.error("Failed to fetch delivery points:", error);
                clearDeliverySelection();
            } finally {
                setDeliveryPointsLoading(false);
            }
        };

        fetchDeliveryPoints();
    }, [
        customerNumber,
        props.masterProductNumber,
        getDeliveryPoints,
        restoreDeliverySelection,
        clearDeliverySelection,
        variantSwitchFlagKey,
    ]);

    // Cleanup delivery selection when component unmounts (user navigates away)
    useEffect(() => {
        return () => {
            // Only clear if not switching variants (variant switch flag would be set)
            const isVariantSwitch = sessionStorage.getItem(variantSwitchFlagKey) === "true";
            if (!isVariantSwitch) {
                clearDeliverySelection();
            }
        };
    }, [clearDeliverySelection, variantSwitchFlagKey]);

    // Helper function to format address for display (without comma between zip and city)
    const formatAddressForLabel = (address: DA_DeliveryAddress): string => {
        const parts = [];
        if (address.streetName && address.streetNumber) {
            parts.push(`${address.streetName} ${address.streetNumber}`);
        }
        // Combine zip code and city with space instead of comma
        const locationParts = [];
        if (address.zipCode) locationParts.push(address.zipCode);
        if (address.city) locationParts.push(address.city);
        if (locationParts.length > 0) {
            parts.push(locationParts.join(" "));
        }
        return parts.join(", ");
    };

    // Get delivery points for selected address
    const getDeliveryPointsForSelectedAddress = () => {
        const selectedAddress = deliveryAddresses.find(
            (addr) => addr.id === selectedDeliveryAddress
        );
        return selectedAddress?.deliveryPoints || [];
    };

    // Generate address dropdown options
    const addressOptions: DA_SelectOption[] = deliveryAddresses
        .sort((a, b) => {
            // Sort isPrimary addresses first
            if (a.isPrimary && !b.isPrimary) return -1;
            if (!a.isPrimary && b.isPrimary) return 1;
            return 0;
        })
        .map((address) => ({
            value: address.id,
            label: formatAddressForLabel(address),
        }));

    // Get the selected address label for context display
    const selectedAddressLabel = deliveryAddresses.find(
        (addr) => addr.id === selectedDeliveryAddress
    )
        ? formatAddressForLabel(
              deliveryAddresses.find((addr) => addr.id === selectedDeliveryAddress)!
          )
        : undefined;

    // Generate delivery point dropdown options
    type DeliveryPointOption =
        | DA_DeliveryPoint
        | { id: string; name: string; description?: string };

    const deliveryPointOptions: DeliveryPointOption[] = [
        // Always include "Standard delivery point" as first option
        {
            id: "standard-delivery-point",
            name: getDictionaryString("siloAndHouses.standardDeliveryPoint"),
            description: "",
        },
        // Add other delivery points for selected address
        ...getDeliveryPointsForSelectedAddress(),
    ];

    // Handle address selection change
    const handleAddressChange = (selectedOption: DA_SelectOption) => {
        const addressId = selectedOption.value as string;
        setSelectedDeliveryAddress(addressId);

        // Always default to "Standard delivery point" when changing address
        setSelectedDeliveryPoint("standard-delivery-point");
    };

    // Handle delivery point selection change
    const handleDeliveryPointChange = (deliveryPoint: DeliveryPointOption) => {
        setSelectedDeliveryPoint(deliveryPoint.id);
    };

    const [currentVariantId, setCurrentVariantId] = useState<string | undefined>(
        props.variantEntityId
    );

    useEffect(() => {
        if (props.price) {
            setPrice(props.price);
        }
    }, [props.price]);

    useEffect(() => {
        if (
            price &&
            price?.quantityDiscounts &&
            price?.quantityDiscounts[0]?.discount?.productDiscountEndDate
        ) {
            setSalesEndDate(
                price?.quantityDiscounts[0]?.discount?.productDiscountEndDate as string
            );
        }
    }, [price]);

    let favorites = undefined;
    let refreshFavorites = () => {};

    // Wrap the useFavorites call in a try-catch block to avoid errors if the provider is not available
    try {
        const favoritesContext = useFavorites();
        favorites = displayFavoritesList ? favoritesContext.favorites : undefined;
        refreshFavorites = displayFavoritesList ? favoritesContext.refreshFavorites : () => {};
    } catch (error) {
        favorites = undefined;
        refreshFavorites = () => {}; // No-op function as a fallback
    }

    const { addProductToFavorites, removeProductFromFavorites, loading } = useFavoriteList(
        customerNumber,
        customerNumber
    );

    const [isFavorite, setIsFavorite] = useState(false);

    const canShowStockStatus = !props.hasVariants || currentVariantId;

    useEffect(() => {
        if (favorites instanceof Set) {
            let isInFavorites = false;

            // If the product has variants and retailVariantId is empty, check if any variant is in favorites
            if (props.hasVariants && !props.retailVariantId) {
                // Flatten all variant IDs from the variant groups
                const allVariantIds = props.variantGroups.flatMap((group) =>
                    Object.values(group.options).flatMap((option) => option.entityIds)
                );

                // Check if any of these variant IDs exist in the favorites set
                isInFavorites = allVariantIds.some((variantId) => favorites.has(variantId));
            }
            // Otherwise, check if the specific variant or main product ID is in the favorites
            else if (props.variantEntityId) {
                isInFavorites = favorites.has(props.variantEntityId);
            } else {
                isInFavorites = favorites.has(props.entityId);
            }

            setIsFavorite(isInFavorites);
        }
    }, [
        favorites,
        props.variantEntityId,
        props.entityId,
        props.hasVariants,
        props.retailVariantId,
        props.variantGroups,
    ]);

    const navigate = useNavigate();
    const [selectedVariantEntity, setSelectedVariantEntity] = useState<{
        variantEntityId: string;
        url: string;
    }>();

    // Find if product has redirectUrl in fieldGroups data
    const hasProductRedirectUrl = (productDataProps) => {
        const productRedirectKey = "redirectUrl";
        // Check if the JSON data contains the fieldGroups array
        if (productDataProps.fieldGroups && Array.isArray(productDataProps.fieldGroups)) {
            // Iterate through each field group
            for (const fieldGroup of productDataProps.fieldGroups) {
                // Check if the field group name is "Skjulte Felter"
                if (fieldGroup.name && fieldGroup.name.toLowerCase() === "skjulte felter") {
                    // Check if the fields object contains the "Product Redirect Url" key
                    if (fieldGroup.fields && fieldGroup.fields[productRedirectKey]) {
                        // Check if the value of "Product Redirect Url" is not an empty string
                        return fieldGroup.fields[productRedirectKey].trim() !== "";
                    }
                }
            }
        }
        // Return false if "Product Redirect Url" is not found or is empty
        return false;
    };

    // NOTE: Related products are disabled for now

    // const settings = useMemo(
    //     () => ({
    //         language: "da",
    //         currency: "DKK",
    //         displayedAtLocation: "ProductDetails",
    //         user: relewiseUser(),
    //     }),
    //     [relewiseUser]
    // );

    // const viewedAfterViewingProductBuilder = new ProductsViewedAfterViewingProductBuilder(settings)
    //     .setSelectedProductProperties({
    //         displayName: true,
    //         pricing: true,
    //         allData: true,
    //         brand: true,
    //         allVariants: true,
    //     })
    //     .setNumberOfRecommendations(10)
    //     .product({ productId: props.entityId });

    // useEffect(() => {
    //     if (props.useRelewiseRelatedProducts) {
    //         getRecommender()
    //             .recommendProductsViewedAfterViewingProduct(
    //                 viewedAfterViewingProductBuilder.build()
    //             )
    //             .then((result) => {
    //                 setRelatedProducts(result.recommendations);
    //             })
    //             .catch((error: ProblemDetailsError) => console.error(error));
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [props.entityId]);

    useEffect(() => {
        if (props.fieldGroups) {
            setQuantityOnPalletValue(
                props.fieldGroups.find((group) => group.id === "hiddenFields")?.fields
                    ?.quantityOnPallet || ""
            );
        }
    }, [props.fieldGroups]);

    // Get field from hidden fields
    const getFieldFromHiddenFields = (fieldName) =>
        props.fieldGroups.find((group) => group.id === "hiddenFields")?.fields?.[fieldName] || "";

    const redirectUrl = getFieldFromHiddenFields("redirectUrl");

    // Get field from hidden fields
    const getFieldFromSpecificationsFields = (fieldName) =>
        props.fieldGroups.find((group) => group.id === "specification")?.fields?.[fieldName] || "";

    const productColor = getFieldFromSpecificationsFields("Farve");
    const productSize = getFieldFromSpecificationsFields("Størrelse");
    const productBrand = getFieldFromSpecificationsFields("Mærke");
    const productWeigtKg = getFieldFromSpecificationsFields("Nettovægt (kg)");

    // Get special freight description and information from hidden fields
    const specialFreightDescription = getFieldFromHiddenFields("specialFreightDescription");
    const specialFreightOverlayText = getFieldFromHiddenFields("specialFreightInformation");
    const hasSpecialFreight = specialFreightOverlayText ? true : false;
    const minimumSalesQuantity = getFieldFromHiddenFields("minimumSalesQuantity");

    const showDiscountAmount = getDictionaryString("discount.showDiscountAmount");
    const discountAmountTitle = getDictionaryString("discount.discountAmountTitle");

    const deliveryLinkText = getDictionaryString(
        hasSpecialFreight ? "ProductPageDeliveryFeeLinkOverwrite" : "ProductPageDeliveryFeeLink"
    );
    const deliveryModalTitle = getDictionaryString(
        hasSpecialFreight ? "deliveryInfoOverwrite" : "deliveryInfo"
    );

    const hasQuantityOnPallet = isGreaterThanZero(quantityOnPalletValue);

    // Product is available to buy if it does not have a product redirect URL
    const isAvailableToBuy = !hasProductRedirectUrl(props);

    const shortDescriptions = useShortDescription(props.shortDescription, props.description);
    const descriptionAccordionRef = useRef<DA_ProductDescriptionRefInterface>();

    // State to manage selected variants
    const [selectedVariants, setSelectedVariants] = useState({});
    const [optionGroups, setOptionGroups] = useState(props.variantGroups);

    const productUrl = `${props.canonicalUrl}/${props.webName}`;

    const quantityAsInt = parseInt(quantityOnPalletValue);

    useEffect(() => {
        if (allowTracking()) {
            getTracker()?.trackProductView({
                productId: props.entityId,
                variantId: props.variantEntityId,
                user: relewiseUser(),
            });
        }
    }, [
        customerNumber,
        getTracker,
        relewiseUser,
        props.entityId,
        props.variantEntityId,
        allowTracking,
    ]);

    const handleFavoriteToggle = useCallback(() => {
        const action = isFavorite ? removeProductFromFavorites : addProductToFavorites;
        const toastText = isFavorite
            ? getDictionaryString("ToastRemovedFromFavoritesText")
            : getDictionaryString("ToastAddedToFavoritesText");

        action({
            productId: props.entityId,
            variantId: props.variantEntityId,
        }).then(() => {
            refreshFavorites();
            toast.custom(() => (
                <DA_Toast
                    href={favoritesListUrl}
                    goTo={getDictionaryString("showFavorites")}
                    altStyle={true}
                    message={
                        <>
                            <div>{toastText}</div>
                            <div className="break-all">{props.webName}</div>
                        </>
                    }
                />
            ));
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFavorite,
        removeProductFromFavorites,
        props.entityId,
        props.variantEntityId,
        addProductToFavorites,
    ]);

    // Effect to pre-select variants if variantEntityId exists
    useEffect(() => {
        if (props.variantEntityId) {
            // Initialize selected variants object
            const selected = {};

            // Loop through variant groups
            props.variantGroups.forEach((group) => {
                // Find the option corresponding to the variantEntityId
                const selectedOption = Object.entries(group.options).find(([_key, value]) =>
                    value.entityIds.includes(props.variantEntityId)
                );

                if (selectedOption) {
                    // Set the selected variant option
                    selected[group.name] = selectedOption[1].value; // Use the value property of the selected option
                }
            });

            // Update state with selected variants
            setSelectedVariants(selected);
        }
    }, [props.variantEntityId, props.variantGroups]);

    // Function to handle variant selection
    const handleVariantChange = (groupName: string, option: DA_SelectOption) => {
        // Convert to string if your variant keys are always strings:
        const chosenValue = String(option.value);

        setSelectedVariants((prev) => {
            const updated = { ...prev, [groupName]: chosenValue };

            // Intersection logic example:
            const resultArrays: string[][] = [];
            Object.values(updated).forEach((value) => {
                props.variantGroups.forEach((variantGroup) => {
                    const found = Object.values(variantGroup.options).find(
                        (opt) => String(opt.value) === value
                    );
                    if (found?.entityIds) {
                        resultArrays.push(found.entityIds);
                    }
                });
            });

            if (resultArrays.length) {
                // Intersection
                const intersection = resultArrays.reduce((acc, curr) =>
                    acc.filter((x) => curr.includes(x))
                );
                if (intersection.length) {
                    const discountVariantIds = new Set(price?.variantDiscounts ?? []);
                    const discountedMatch = intersection.find((variantId) =>
                        discountVariantIds.has(variantId)
                    );
                    const newVariantId = discountedMatch ?? intersection[0];
                    if (newVariantId !== currentVariantId) {
                        setCurrentVariantId(newVariantId);
                    }
                }
            }

            return updated;
        });
    };

    const getIntersection = (arrayOfArrays) => {
        return arrayOfArrays?.reduce((acc, currentValue) => {
            return acc.filter((res) => currentValue?.find((value) => value === res));
        });
    };

    const loadVariantPrice = useCallback(async () => {
        if (selectedVariantEntity) {
            const page = await getPageByUrl(selectedVariantEntity?.url);
            const product = page ? (page?.product as DA_NewProduct) : undefined;
            if (product) {
                const priceData = await getProductVariantPrice(
                    product?.masterProductNumber,
                    product?.retailVariantId,
                    Boolean(product?.variantEntityId)
                );
                setPrice(priceData);
            }
        }
    }, [getProductVariantPrice, selectedVariantEntity]);

    useEffect(() => {
        setOptionGroups(props.variantGroups);

        if (selectedVariants) {
            const result = [];

            // get ids for each selected item in selectedVariants
            Object.values(selectedVariants).forEach((value) => {
                // Loop through each variant group
                props.variantGroups.forEach((variantGroup) => {
                    const selectedOptionIds = Object.values(variantGroup.options).find(
                        (val) => val.value === value
                    )?.entityIds;

                    if (selectedOptionIds) {
                        result.push(selectedOptionIds);
                    }
                });
            });

            if (result.length > 1) {
                const allSelected = [];
                const optionGroups = [];
                result.map((r) => allSelected.push(...r));

                // Calculate disabled option state based on selection
                props.variantGroups.forEach((variantGroup) => {
                    const options = Object.values(variantGroup.options).map((opt) => {
                        return {
                            ...opt,
                            disabled: getIntersection([opt.entityIds, allSelected])?.length === 0,
                        };
                    });

                    optionGroups.push({
                        ...variantGroup,
                        options,
                    });
                });

                setOptionGroups(optionGroups);
            }

            // compare arrays in result
            if (result.length) {
                if (currentVariantId && currentVariantId !== props.variantEntityId) {
                    const variantUrl = props.urls[currentVariantId];
                    if (variantUrl) {
                        setSelectedVariantEntity({
                            variantEntityId: currentVariantId,
                            url: variantUrl,
                        });
                    }
                }
            }
        }
    }, [
        props.urls,
        props.variantEntityId,
        props.variantGroups,
        selectedVariants,
        variantGroupsLength,
        currentVariantId,
    ]);

    useEffect(() => {
        if (selectedVariantEntity) {
            const url = selectedVariantEntity.url;
            setSelectedVariantEntity(undefined); // otherwise router gets stuck on this page
            setPrice(undefined); // Show skeleton while loading new price

            if (props.isQuickOrder && props.onVariantChange) {
                props.onVariantChange(selectedVariantEntity);
            } else {
                // Save delivery selection before variant navigation
                saveDeliverySelection();
                // Set flag to indicate this is a variant switch
                sessionStorage.setItem(variantSwitchFlagKey, "true");

                // TODO: figure out disabled items
                navigate(url, { replace: true });
                loadVariantPrice();
            }

            setVariantsComplete(true);
        }
    }, [
        loadVariantPrice,
        navigate,
        props,
        selectedVariantEntity,
        saveDeliverySelection,
        variantSwitchFlagKey,
    ]);

    // Convert formatted price string to float and ensure two decimals
    const formattedPriceString = formatNumber(price?.priceWithoutVat, currentCulture, {
        decimals: 2,
    });
    const priceWithTwoDecimalsString = parseFloat(formattedPriceString.replace(",", ".")).toFixed(
        2
    );

    const image = useRef(props.media && props.media.length > 0 ? props.media[0].url : null).current;

    // Extract the category from the URL
    const category = props?.canonicalUrl?.split("/").slice(0, -1).join("_").replace(/^_/, "");

    // Get the name of the last item in the currentPathDetails array
    const lastItemName = currentPathDetails.at(-1)?.name ?? "";

    // Get the id of the last item in the currentPathDetails array
    const getLastItemId = currentPathDetails.at(-1)?.categoryId ?? "";

    const formatPrice = useCallback(
        (price: number) => formatNumber(price, "da-DK", { decimals: 2 }),
        []
    );

    // Extracting brand from props.specs
    let brand;
    const fieldGroups = props.fieldGroups;
    for (const fieldGroup of fieldGroups) {
        if (fieldGroup.name === "Specifikation") {
            brand = fieldGroup.fields.Brand;
            break;
        }
    }

    // GTM Tracking product viewed
    const trackProductEvent = useProductTracker({
        name: props.webName,
        price: formatPrice(price?.priceWithoutVat),
        productNumber: props.entityId,
        currency: "DKK",
        category: category,
        brand: brand,
        listId: getLastItemId.toString(),
        listName: lastItemName,
        quantity: quantity,
    });

    useEffect(() => {
        if (price?.priceWithoutVat && price?.priceWithoutVat !== 0) {
            // GTM Tracking
            trackProductEvent("view_item");
            pushToDataLayer({
                event: "google_ads_remarketing",
                ecomm_pagetype: "product",
                ecomm_totalvalue: price?.priceWithoutVat,
                ecomm_prodid: props.masterProductNumber,
            });
        }
    }, [price, props.masterProductNumber, trackProductEvent]);

    // Shipping modal info
    const openShippingInfoModal = useCallback(() => {
        showModal(
            <DA_DeliveryInfoModalContent specialFreightOverlayText={specialFreightDescription} />,
            {
                size: ModalSize.XXL,
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal]);

    // Shipping bottom sheet info
    const openDynamicOverlay = useCallback(() => {
        showOverlay({
            id: "delivery-filter_open",
            title: deliveryModalTitle,
            content: (
                <BottomSheetDeliveryInfo
                    version="v1"
                    specialFreightOverlayText={specialFreightDescription}
                />
            ),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOverlay]);

    const extraInfoItems = useMemo(() => {
        const tabs = [];

        // Add tabs for each field group excluding "general"
        if (props.fieldGroups?.length) {
            props.fieldGroups.forEach((group) => {
                if (!group.hideOnWeb) {
                    if (group.layout === "Text") {
                        let textContent = "";

                        // Iterate over the keys of the fields object to find the appropriate content
                        Object.keys(group.fields).forEach((key) => {
                            textContent = group.fields[key];
                        });

                        tabs.push({
                            title: group.name,
                            content: (
                                <DA_ContentBox>
                                    {isMobileOrTablet ? (
                                        <>
                                            {hasQuantityOnPallet && group.id === "description" && (
                                                <div className={S.labelTagWrapper}>
                                                    <DA_Tag color="neutral" size="dynamic">
                                                        {getDictionaryItem("quantityonpallettext", {
                                                            quantity: quantityOnPalletValue,
                                                        })}
                                                    </DA_Tag>
                                                </div>
                                            )}
                                            <p
                                                dangerouslySetInnerHTML={{ __html: textContent }}
                                                className={S.productDescription}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            {hasQuantityOnPallet && group.id === "description" && (
                                                <div className={S.labelTagWrapper}>
                                                    <DA_Tag color="neutral" size="dynamic">
                                                        {getDictionaryItem("quantityonpallettext", {
                                                            quantity: quantityOnPalletValue,
                                                        })}
                                                    </DA_Tag>
                                                </div>
                                            )}
                                            <DA_ProductDescription
                                                description={textContent}
                                                ref={productDescriptionRef}
                                            />
                                        </>
                                    )}
                                </DA_ContentBox>
                            ),
                        });
                    } else if (group.layout === "DocumentLinks") {
                        tabs.push({
                            title: group.name,
                            content: (
                                <DA_ContentBox>
                                    <div className={S.linkList}>
                                        {group.media?.map((document) => (
                                            <div className={S.linkListItem} key={document.url}>
                                                <DA_InlineLink
                                                    title={document.name}
                                                    href={document.url}
                                                    target="_blank"
                                                    icon={DA_IconNames.Pdf}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </DA_ContentBox>
                            ),
                        });
                    } else {
                        tabs.push({
                            title: group.name,
                            content: (
                                <DA_ContentBox>
                                    <table
                                        className={S.specifications}
                                        style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                        }}
                                    >
                                        <tbody>
                                            {Object.entries(group.fields).map(
                                                ([key, value], index) => (
                                                    <tr
                                                        key={index}
                                                        style={{
                                                            background:
                                                                index % 2 === 0
                                                                    ? "#f5f5f5"
                                                                    : undefined,
                                                        }}
                                                    >
                                                        <td
                                                            className={S.tableFirstTd}
                                                            valign="top"
                                                            style={{
                                                                padding: "5px",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            {key}
                                                        </td>
                                                        <td
                                                            valign="top"
                                                            style={{ padding: "5px" }}
                                                            dangerouslySetInnerHTML={{
                                                                __html: value,
                                                            }}
                                                        />
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </DA_ContentBox>
                            ),
                        });
                    }
                }
            });
        }

        return tabs;
    }, [
        props.fieldGroups,
        isMobileOrTablet,
        hasQuantityOnPallet,
        getDictionaryItem,
        quantityOnPalletValue,
    ]);

    const scrollToExtraInfo = () => {
        // For Mobile or Tablet
        if (isMobileOrTablet) {
            if (descriptionAccordionRef.current) {
                descriptionAccordionRef.current.showFullDescription(); // Open the accordion
                descriptionAccordionRef.current.scrollIntoView(); // This should perform smooth scrolling
            }
        } else {
            // For Desktop
            if (tabRef.current) {
                tabRef.current.showDescriptionTab();
            }

            setTimeout(() => {
                if (productDescriptionRef.current) {
                    productDescriptionRef.current.showFullDescription();
                }
            }, 50);
        }
    };

    const calculateRangeOffset = (quantityOnPallet: number) => {
        return Math.floor(quantityOnPallet * 0.25); // ±25% of quantityOnPallet
    };

    const checkIfVariantIsSelected = useCallback(() => {
        if (Object.keys(selectedVariants).length < props.variantGroups.length) {
            setVariantsComplete(false);
        }
    }, [props.variantGroups.length, selectedVariants]);

    const latestQuantityRef = useRef(quantity);

    useEffect(() => {
        latestQuantityRef.current = quantity;
    }, [quantity]);

    useEffect(() => {
        const intValue = quantity;
        setModalViewState(modalState.hide);

        if (!isNaN(quantity)) {
            const rangeOffset = calculateRangeOffset(parseInt(quantityOnPalletValue));
            for (let numberOfPallets = 1; numberOfPallets <= 100; numberOfPallets++) {
                const totalPalletQuantity = numberOfPallets * parseInt(quantityOnPalletValue);
                const lowerBound = totalPalletQuantity - rangeOffset || 0;
                const upperBound = totalPalletQuantity + rangeOffset || 0;

                if (
                    intValue !== totalPalletQuantity &&
                    intValue >= lowerBound &&
                    intValue <= upperBound
                ) {
                    setModalViewState(modalState.show);
                    setNumberOfPallets(numberOfPallets);
                    setTotalPalletQuantity(totalPalletQuantity);
                    return;
                } else if (intValue === totalPalletQuantity) {
                    setModalViewState(modalState.hide);
                    return;
                }
            }
        }
    }, [quantity, quantityOnPalletValue]);

    const check = useCallback(
        (
            showModalState: modalState,
            defaultQuantityOnPallet: number,
            totalPalletQuantity: number,
            numberOfPallets: number,
            choosedValue: boolean
        ) => {
            return new Promise<number>((resolve) => {
                if (showModalState === modalState.show && !choosedValue) {
                    const handleSelection = (selectedValue) => {
                        setQuantity(selectedValue);
                        setChoosedValue(true);
                        resolve(selectedValue); // Resolve the promise after the state is updated with the new quantity
                    };

                    if (isMobileOrTablet) {
                        presentBottomSheet(
                            <DA_QuantityOnPalletOverlay
                                quantity={latestQuantityRef.current}
                                quantityOnPallet={totalPalletQuantity}
                                defaultQuantityOnPallet={defaultQuantityOnPallet}
                                numberOfPallets={numberOfPallets}
                                onSelection={handleSelection}
                            />,
                            {
                                id: "shop-quantity-bottom-sheet",
                                contentPadding: true,
                                headerTitle: getDictionaryString("shopquantityonpallettitle"),
                                snapPoints: ({ minHeight }) => [minHeight],
                                hideCloseButton: true,
                            }
                        );
                    } else {
                        showModal(
                            <DA_Modal title={getDictionaryString("shopquantityonpallettitle")}>
                                <DA_QuantityOnPalletOverlay
                                    quantity={latestQuantityRef.current}
                                    quantityOnPallet={totalPalletQuantity}
                                    defaultQuantityOnPallet={quantityAsInt}
                                    numberOfPallets={numberOfPallets}
                                    onSelection={handleSelection}
                                />
                            </DA_Modal>,
                            {
                                size: ModalSize.XS,
                                shouldCloseOnEsc: false,
                                shouldCloseOnOverlayClick: false,
                            }
                        );
                    }
                } else {
                    resolve(latestQuantityRef.current); // Resolve immediately if no modal is shown
                }
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [getDictionaryString, isMobileOrTablet, presentBottomSheet, quantityAsInt, showModal]
    );

    const addProductToCart = useCallback(
        async (
            modalViewState: modalState,
            defaultQuantityOnPallet: number,
            totalPalletQuantity: number,
            numberOfPallets: number,
            choosedValue: boolean
        ) => {
            const selectedQuantity = await check(
                modalViewState,
                defaultQuantityOnPallet,
                totalPalletQuantity,
                numberOfPallets,
                choosedValue
            ); // Wait for check to complete and get the latest quantity

            if (Object.keys(selectedVariants).length < props.variantGroups.length) {
                setVariantsComplete(false);
            } else {
                setAwaitingResponse(true);
                // GTM Tracking
                trackProductEvent("add_to_cart");
                pushToDataLayer({
                    event: "google_ads_remarketing",
                    ecomm_pagetype: "product",
                    ecomm_totalvalue: parseFloat(priceWithTwoDecimalsString),
                    ecomm_prodid: props.entityId,
                });

                // Handle delivery point ID - send empty string if "standard-delivery-point" is selected
                const deliveryPointIdToSend =
                    selectedDeliveryPoint === "standard-delivery-point"
                        ? ""
                        : selectedDeliveryPoint;

                // Get the locationId from the selected address
                const selectedAddressData = deliveryAddresses.find(
                    (addr) => addr.id === selectedDeliveryAddress
                );
                const addressIdToSend = selectedAddressData?.locationId || "";

                addToCart({
                    productId: props.variantEntityId,
                    quantity: selectedQuantity, // Use the latest quantity
                    addressId: addressIdToSend,
                    deliveryPointId: deliveryPointIdToSend,
                }).finally(() => setAwaitingResponse(false));
            }
        },
        [
            check,
            selectedVariants,
            props.variantGroups.length,
            props.entityId,
            props.variantEntityId,
            trackProductEvent,
            priceWithTwoDecimalsString,
            addToCart,
            selectedDeliveryAddress,
            selectedDeliveryPoint,
            deliveryAddresses,
        ]
    );

    // // Discount table
    // const discountTableData = useMemo(() => {
    //     return (
    //         props?.price?.quantityDiscounts?.map((discount) => ({
    //             quantityFrom: discount.quantityFrom,
    //             quantityTo: discount.quantityTo || Infinity,
    //             price: discount.price,
    //         })) || []
    //     );
    // }, [props?.price]);

    // Calculate the remaining time for a discount
    const calculateRemainingTime = (endDate: string) => {
        const now = new Date();
        const end = new Date(endDate);
        const diff = end.getTime() - now.getTime();

        if (diff <= 0 || endDate === "1900-01-01T12:00:00") return null; // Ignore past or invalid dates

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        return `${
            days > 0 ? `${days} ${getDictionaryString("discount.daysShort")} ` : ""
        }${hours} ${getDictionaryString("discount.hoursShort")} ${minutes}${getDictionaryString(
            "discount.minutesShort"
        )}`;
    };

    // Map and process discount table data
    // const discountTableData = useMemo(() => {
    //     return (
    //         price?.quantityDiscounts
    //             ?.filter((discount) => {
    //                 // Ignore invalid ranges and past dates
    //                 const remainingTime = calculateRemainingTime(discount.endDate);
    //                 return (
    //                     discount.quantityFrom !== 0 &&
    //                     discount.quantityTo !== 0 &&
    //                     remainingTime !== null
    //                 );
    //             })
    //             .map((discount) => ({
    //                 ...discount,
    //                 remainingTime: calculateRemainingTime(discount.endDate), // Add remaining time for active discounts
    //             })) || []
    //     );
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [price]);

    const sanitizeDiscounts = (discounts: QuantityDiscount[]): QuantityDiscount[] =>
        discounts.map((d) => (d.quantityFrom === 0 ? { ...d, quantityFrom: 1 } : d));

    const discountTableData = useMemo(() => {
        return (
            sanitizeDiscounts(price?.quantityDiscounts ?? [])
                .filter((discount) => {
                    const remainingTime = calculateRemainingTime(discount.endDate);
                    return (
                        discount.quantityFrom !== 0 &&
                        discount.quantityTo !== 0 &&
                        remainingTime !== null
                    );
                })
                .map((discount) => ({
                    ...discount,
                    remainingTime: calculateRemainingTime(discount.endDate),
                })) || []
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [price]);

    const { optionHasDiscount } = useOptionHasDiscount(price, optionGroups, selectedVariants);

    const calculateDiscountedPrice = useCallback(() => {
        if (discountTableData?.length > 0) {
            const applicableDiscount = discountTableData.find(
                (item) => quantity >= item.quantityFrom && quantity <= (item.quantityTo || Infinity)
            );
            return applicableDiscount?.discount?.priceWithDiscount;
        }
        return null;
    }, [discountTableData, quantity]);

    const currentDiscount = discountTableData.find(
        (discount) =>
            quantity >= discount.quantityFrom &&
            quantity <= (discount.quantityTo ?? Infinity) &&
            discount.discount?.priceWithDiscount > 0
    );

    const currentDiscountEndDate = currentDiscount?.discount?.productDiscountEndDate;

    useEffect(() => {
        // Find the discount row that matches the current quantity
        const currentDiscount = discountTableData.find(
            (discount) =>
                quantity >= discount.quantityFrom &&
                quantity <= (discount.quantityTo ?? Infinity) &&
                discount.discount?.priceWithDiscount > 0
        );

        setShowDiscount(!!currentDiscount);
    }, [discountTableData, quantity]);

    const calculatePrice = useCallback(() => {
        if (discountTableData?.length > 0 && price) {
            const applicableDiscount = discountTableData.find(
                (item) => quantity >= item.quantityFrom && quantity <= (item.quantityTo || Infinity)
            );
            return applicableDiscount?.price || price?.priceWithoutVat;
        }
        return price?.priceWithoutVat;
    }, [discountTableData, price, quantity]);

    const openDynamicDiscountOverlay = useCallback(() => {
        if (discountTableData.length === 0) {
            console.warn("Discount table data is not yet available.");
            return;
        }

        showOverlay({
            id: "discount_amount_open",
            title: discountAmountTitle,
            content: (
                <DiscountTable
                    type="Mobile"
                    version="v1"
                    discountTable={discountTableData}
                    currentQuantity={quantity}
                    clickableRows
                    minimumSalesQuantity={minimumSalesQuantity}
                    onRowClick={(qty) => {
                        setQuantity(qty);
                        closeOverlay();
                    }}
                />
            ),
        });
    }, [
        discountTableData,
        showOverlay,
        discountAmountTitle,
        quantity,
        closeOverlay,
        minimumSalesQuantity,
    ]);

    // Calculate active row index

    // const activeRowIndex = useMemo(() => {
    //     return discountTableData.findIndex(
    //         (item) =>
    //             item.quantityFrom <= quantity &&
    //             (item.quantityTo >= quantity || item.quantityTo === Infinity) &&
    //             item.remainingTime // Ensure validity
    //     );
    // }, [discountTableData, quantity]);

    // Extract the remaining time for the active discount
    // const activeDiscountRemainingTime =
    //     activeRowIndex !== -1 ? discountTableData[activeRowIndex]?.remainingTime : null;
    // activeRowIndex !== -1 ? discountTableData[activeRowIndex]?.remainingTime : null;

    const computedPrice = useMemo(
        () => ({
            ...price,
            priceWithoutVat: calculatePrice(),
            discountPrice: calculateDiscountedPrice(),
        }),
        [price, calculatePrice, calculateDiscountedPrice]
    );

    const currentPrice = price?.discountPrice > 0 ? price?.discountPrice : price?.priceWithoutVat;

    const schemaMarkupProduct = {
        "@context": "https://schema.org",
        "@type": "Product",
        brand: productBrand,
        color: productColor,
        size: productSize,
        weight: productWeigtKg,
        category: lastItemName,
        productID: props.masterProductNumber,
        name: props.webName,
        description: shortDescriptions,
        image: B2bImageSrc(image, ImageConfig.PdpMainImage),
        offers: {
            "@context": "https://schema.org",
            "@type": "Offer",
            price: (typeof currentPrice === "undefined" ? 0 : currentPrice).toFixed(2),
            priceCurrency: computedPrice?.currency || "DKK",
        },
    };

    return (
        <>
            <div className={S.container}>
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(schemaMarkupProduct)}
                    </script>
                </Helmet>

                {isFarmInTimeEnabled &&
                    globalThis.isAuthenticated &&
                    isAvailableToBuy &&
                    !isMobileOrTablet && (
                        <div className={S.wishListButton}>
                            <DA_WishListButton
                                productId={props.entityId}
                                productName={props.webName}
                                productImage={image}
                                variantId={props.variantEntityId}
                                productPageUrl={productUrl}
                                isVariantSelected={() => checkIfVariantIsSelected()}
                                variantSelected={Object.keys(selectedVariants).length}
                                variantGroups={props.variantGroups.length}
                                quantityOnPallet={hasQuantityOnPallet ? quantityOnPalletValue : ""}
                                productNumber={props.masterProductNumber}
                                price={computedPrice?.priceWithoutVat}
                                minimumSalesQuantity={minimumSalesQuantity}
                            />
                        </div>
                    )}

                {displayFavoritesList && globalThis.isAuthenticated && isAvailableToBuy && (
                    <div className={S.wishListButton}>
                        <div className={cn(S.favBtn, isFavorite && S.isFavorite)}>
                            {props.hasVariants ? (
                                <DA_Button
                                    onClick={() => {
                                        if (
                                            Object.keys(selectedVariants).length <
                                            props.variantGroups.length
                                        ) {
                                            checkIfVariantIsSelected(); // Ensure all variants are selected
                                        } else {
                                            handleFavoriteToggle(); // Call the favorite toggle function
                                        }
                                    }}
                                    icon={
                                        isFavorite
                                            ? DA_IconNames.HeartSolid
                                            : DA_IconNames.HeartOutline
                                    }
                                    disabled={loading}
                                />
                            ) : (
                                <DA_Button
                                    onClick={handleFavoriteToggle}
                                    icon={
                                        isFavorite
                                            ? DA_IconNames.HeartSolid
                                            : DA_IconNames.HeartOutline
                                    }
                                    disabled={loading}
                                />
                            )}
                        </div>
                    </div>
                )}
                <div className={S.imageWrapper}>
                    <DA_ImageSlider
                        media={[
                            ...props.media.map((image) => ({
                                ...image,
                                alt: image.name,
                            })),
                        ]}
                        startOnVideos={startOnVideos}
                    />
                </div>

                <div className={S.priceSection}>
                    <div className={S.productNumber}>
                        {getDictionaryString("product number")} {props.masterProductNumber}
                        {isMobileOrTablet && props.stockStatus && globalThis.isAuthenticated && (
                            <span className={S.stockMobileWrapper}>
                                <DA_StockStatus large comment={props.stockStatus} />
                            </span>
                        )}
                    </div>

                    {/* {props.newProduct && (
                        <div className={S.splashWrapper}>
                            <DA_NewProductSplash
                                text={getDictionaryString("new splat")}
                                className={S.newProductSplash}
                            />
                        </div>
                    )} */}

                    <div className={S.titleWrapper}>
                        <DA_Title h1 inheritColor className={S.hSmall}>
                            {props.webName}
                        </DA_Title>
                    </div>

                    {props.description ? (
                        <div className={S.descriptionTextWrapper}>
                            <div>
                                <div
                                    className={S.descriptionText}
                                    dangerouslySetInnerHTML={{ __html: shortDescriptions }}
                                />
                                <DA_ButtonLink
                                    className={S.link}
                                    title={getDictionaryString("read more")}
                                    onClick={scrollToExtraInfo}
                                />
                            </div>
                        </div>
                    ) : null}

                    {optionGroups?.map((group, variantIndex) => {
                        const variantId = `variant-${variantIndex}`;

                        const sortedOptions = Object.values(group.options)
                            .sort((a, b) => (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity))
                            .map((option) => ({
                                label: option.value,
                                optionLabel: optionHasDiscount(variantIndex, option.entityIds) ? (
                                    <span className={S.optionWithDiscount}>
                                        {option.value}
                                        {!hidePrice && (
                                            <DA_Tag color="yellow" size="large">
                                                {getDictionaryString("offer splat")}
                                            </DA_Tag>
                                        )}
                                    </span>
                                ) : undefined,
                                value: option.value,
                                disabled: option.disabled,
                            }));

                        return isMobileOrTablet ? (
                            <div className={S.selectWrapper} key={group.name}>
                                {/* Wrap in the same input wrapper for consistency in style */}
                                <DA_InputWrapper forId={variantId}>
                                    {/* Use BottomSheetSelect for mobile */}
                                    <BottomSheetSelect
                                        options={sortedOptions}
                                        selectName={group.name}
                                        onChange={(option) =>
                                            handleVariantChange(group.name, option)
                                        }
                                        defaultValue={selectedVariants[group.name]}
                                        placeholder={`${getDictionaryString(
                                            "choose"
                                        )} ${group.name.toLocaleLowerCase()}`}
                                        // you can add more props as needed
                                    />
                                </DA_InputWrapper>
                            </div>
                        ) : (
                            <div className={S.selectWrapper} key={group.name}>
                                <DA_InputWrapper forId={group.name}>
                                    <DA_Select
                                        key={variantId}
                                        id={variantId}
                                        selectName={getDictionaryString(group.name)}
                                        options={sortedOptions}
                                        onChange={(option) =>
                                            handleVariantChange(group.name, option)
                                        }
                                        value={selectedVariants[group.name]} // Pass the selected value from state
                                        placeholder={`${getDictionaryString(
                                            "choose"
                                        )} ${group.name.toLowerCase()}`}
                                        isSearchable={false}
                                        inlineLabel
                                        fullWidth
                                        className={S.customSelect}
                                        // Apply custom prefix for classnames
                                        variantCount={Object.keys(group.options).length}
                                        disableOptionStyling
                                    />
                                </DA_InputWrapper>
                            </div>
                        );
                    })}

                    <DA_Text noPadding className={cn(S.helperText, !variantsComplete && S.show)}>
                        {getDictionaryString("selectVariant")}
                    </DA_Text>

                    {props.energyLabel ? (
                        <div className={S.energyWrapper}>
                            <DA_Tooltip
                                text={
                                    <div>
                                        <img
                                            className={S.energyLargeWrapper}
                                            src={props?.energyLabel?.labelUrl}
                                            alt="Energy label"
                                        />
                                    </div>
                                }
                            >
                                <img
                                    className={S.energyImage}
                                    src={props.energyLabel?.arrowUrl}
                                    alt="Energy mark"
                                />
                            </DA_Tooltip>
                            <DA_InlineLink
                                className={S.energyLabel}
                                href={props.energyLabel?.reportUrl}
                                title={getDictionaryString("ProductSheet")}
                                target="_blank"
                            />
                        </div>
                    ) : null}

                    {/** No product error message */}
                    <div className={cn(S.noProduct, noProduct && S.show)}>
                        {getDictionaryString("ProductPageProductNotAvailable")}
                    </div>
                    {/** Add to Cart Button */}
                    {isAvailableToBuy ? (
                        <>
                            {isMobileOrTablet ? (
                                <>
                                    <div
                                        className={cn(
                                            S.priceContainerMobile,
                                            !showPrices && S.priceDisabled
                                        )}
                                    >
                                        {showDiscount && !hidePrice && (
                                            <div className={S.salesWrapperMobile}>
                                                <div className={S.tagSplash}>
                                                    <DA_Tag color="yellow" size="large">
                                                        {getDictionaryString("offer splat")}
                                                    </DA_Tag>
                                                </div>
                                                {showDiscount ? (
                                                    <div>
                                                        <DA_Countdown
                                                            endDate={currentDiscountEndDate}
                                                        />
                                                    </div>
                                                ) : (
                                                    <Skeleton width={100} height={20} />
                                                )}
                                            </div>
                                        )}

                                        {/* Delivery Address and Points Selection for Mobile */}
                                        {globalThis.isAuthenticated && (
                                            <div className={S.mobileDeliveryWrapper}>
                                                <MobileDeliveryAddressSelect
                                                    options={addressOptions}
                                                    value={selectedDeliveryAddress}
                                                    onChange={handleAddressChange}
                                                    placeholder={getDictionaryString(
                                                        "selectDeliverAddresses"
                                                    )}
                                                    isDisabled={deliveryPointsLoading}
                                                    onAddNewAddress={onAddNewAddressClicked}
                                                />
                                                <MobileDeliveryPointSelect
                                                    options={deliveryPointOptions.map((dp) => ({
                                                        value: dp.id,
                                                        label: dp.name,
                                                        extra:
                                                            dp.description ||
                                                            ("capacityDescription" in dp
                                                                ? dp.capacityDescription
                                                                : undefined),
                                                    }))}
                                                    value={selectedDeliveryPoint}
                                                    onChange={(option) => {
                                                        const deliveryPoint =
                                                            deliveryPointOptions.find(
                                                                (dp) => dp.id === option.value
                                                            );
                                                        if (deliveryPoint)
                                                            handleDeliveryPointChange(
                                                                deliveryPoint
                                                            );
                                                    }}
                                                    placeholder={getDictionaryString(
                                                        "selectDeliverPoint"
                                                    )}
                                                    isDisabled={
                                                        deliveryPointsLoading ||
                                                        !selectedDeliveryAddress
                                                    }
                                                    selectedDeliveryAddress={
                                                        selectedDeliveryAddress
                                                    }
                                                    selectedDeliveryAddressLabel={
                                                        selectedAddressLabel
                                                    }
                                                />
                                            </div>
                                        )}

                                        <div className={S.priceWrapper}>
                                            {showPrices && !hidePrice && (
                                                <div className={S.priceBox}>
                                                    <DA_Price
                                                        price={computedPrice}
                                                        priceLabel={getDictionaryString(
                                                            "unit price"
                                                        )}
                                                        comment={getDictionaryString("excl VAT")}
                                                        alternative
                                                    />
                                                </div>
                                            )}
                                            <div className={S.QuantityPickerBox}>
                                                <DA_QuantityPicker
                                                    onChange={setQuantity}
                                                    value={quantity}
                                                    higherMax={highMax}
                                                    minQty={minimumSalesQuantity}
                                                />
                                            </div>
                                        </div>
                                        {discountTableData.length > 1 && !hidePrice && (
                                            <div className={S.showDiscountBottomSheet}>
                                                <DA_ButtonLink
                                                    title={showDiscountAmount}
                                                    onClick={openDynamicDiscountOverlay}
                                                />
                                            </div>
                                        )}

                                        <div className={S.cartBtnBox}>
                                            <DA_CartButton
                                                title={getDictionaryString("add to cart")}
                                                addToCart={() =>
                                                    addProductToCart(
                                                        modalViewState,
                                                        quantityAsInt,
                                                        totalPalletQuantity,
                                                        numberOfPallets,
                                                        choosedValue
                                                    )
                                                }
                                                showSpinner={awaitingResponse}
                                                disabled={noProduct}
                                                isAvailableToBuy={isAvailableToBuy}
                                                fullWidth
                                            />
                                        </div>
                                    </div>
                                    {isFarmInTimeEnabled &&
                                        globalThis.isAuthenticated &&
                                        isAvailableToBuy &&
                                        isMobileOrTablet && (
                                            <div className={S.wishListButtonList}>
                                                <DA_WishListButton
                                                    productId={props.entityId}
                                                    productName={props.webName}
                                                    productImage={image}
                                                    variantId={props.variantEntityId}
                                                    productPageUrl={productUrl}
                                                    isVariantSelected={() =>
                                                        checkIfVariantIsSelected()
                                                    }
                                                    variantSelected={
                                                        Object.keys(selectedVariants).length
                                                    }
                                                    variantGroups={props.variantGroups.length}
                                                    quantityOnPallet={
                                                        hasQuantityOnPallet
                                                            ? quantityOnPalletValue
                                                            : ""
                                                    }
                                                    productNumber={props.masterProductNumber}
                                                    price={computedPrice?.priceWithoutVat}
                                                    minimumSalesQuantity={minimumSalesQuantity}
                                                    isNotModal
                                                />
                                            </div>
                                        )}
                                </>
                            ) : (
                                <>
                                    {discountTableData.length > 1 && !hidePrice && (
                                        <DiscountTable
                                            discountTable={discountTableData}
                                            currentQuantity={quantity}
                                            type="Desktop"
                                            version="v1"
                                            clickableRows
                                            minimumSalesQuantity={minimumSalesQuantity}
                                            onRowClick={(qty) => {
                                                setQuantity(qty);
                                            }}
                                            priceCurrency={props?.price?.currency}
                                        />
                                    )}
                                    <div className={S.priceContainer}>
                                        <div className={S.offerAndStockWrapper}>
                                            {/* <div className={S.offerWrapper}>
                                            <span className={S.offerTab}>
                                                Køb 3 for2 eller længere tekst
                                            </span>
                                        </div> */}
                                            {showDiscount && !hidePrice && (
                                                <div className={S.salesWrapper}>
                                                    <DA_Tag color="yellow" size="dynamic">
                                                        {getDictionaryString("offer splat")}
                                                    </DA_Tag>
                                                    {showDiscount ? (
                                                        <DA_Countdown
                                                            endDate={currentDiscountEndDate}
                                                        />
                                                    ) : (
                                                        <Skeleton width={100} height={20} />
                                                    )}
                                                </div>
                                            )}
                                            <div className={S.stockWrapper}>
                                                {canShowStockStatus &&
                                                    globalThis?.isAuthenticated &&
                                                    globalThis?.showStockStatus && (
                                                        <StockAmountStatus
                                                            productNumber={
                                                                props.masterProductNumber
                                                            }
                                                            variantId={
                                                                props.hasVariants
                                                                    ? props.retailVariantId
                                                                    : undefined
                                                            }
                                                        />
                                                    )}
                                            </div>
                                        </div>
                                        {globalThis.isAuthenticated && (
                                            <div className={S.addressAndPlacementWrapper}>
                                                <div className={S.addressAndPlacementBox}>
                                                    <div className={S.addressAndPlacementBoxItem}>
                                                        <DA_InputWrapper
                                                            label={getDictionaryString(
                                                                "deliveryAddress"
                                                            )}
                                                            forId="deliver-addresses"
                                                        >
                                                            <DeliveryAddressSelect
                                                                options={addressOptions}
                                                                value={selectedDeliveryAddress}
                                                                onChange={handleAddressChange}
                                                                placeholder={getDictionaryString(
                                                                    "siloAndHouses.selectDeliveryAddress"
                                                                )}
                                                                isDisabled={deliveryPointsLoading}
                                                                id="deliver-addresses"
                                                            />
                                                        </DA_InputWrapper>
                                                    </div>
                                                    <div className={S.addressAndPlacementBoxItem}>
                                                        <DA_InputWrapper
                                                            label={getDictionaryString(
                                                                "deliveryPoint"
                                                            )}
                                                            forId="deliver-addressesPoints"
                                                            tooltip={getDictionaryString(
                                                                "deliveryPointTooltipText"
                                                            )}
                                                        >
                                                            <DA_Select
                                                                options={deliveryPointOptions}
                                                                value={selectedDeliveryPoint}
                                                                onChange={handleDeliveryPointChange}
                                                                {...deliveryPointHandlers}
                                                                placeholder={getDictionaryString(
                                                                    "selectDeliverPoint"
                                                                )}
                                                                disabled={
                                                                    deliveryPointsLoading ||
                                                                    !selectedDeliveryAddress
                                                                }
                                                                id="deliver-addressesPoints"
                                                                fullWidth
                                                            />
                                                        </DA_InputWrapper>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className={S.priceBasics}>
                                            <div className={S.priceSpaceBetween}>
                                                {showPrices && !hidePrice && (
                                                    <DA_Price
                                                        price={computedPrice}
                                                        priceLabel={getDictionaryString(
                                                            "unit price"
                                                        )}
                                                        comment={getDictionaryString("excl VAT")}
                                                        alternative
                                                    />
                                                )}
                                            </div>

                                            <div className={S.priceContainerOptions}>
                                                <DA_QuantityPicker
                                                    onChange={setQuantity}
                                                    value={quantity}
                                                    compactOnMobile
                                                    higherMax={highMax}
                                                    minQty={minimumSalesQuantity}
                                                />
                                                <DA_CartButton
                                                    title={getDictionaryString("add to cart")}
                                                    addToCart={() =>
                                                        addProductToCart(
                                                            modalViewState,
                                                            quantityAsInt,
                                                            totalPalletQuantity,
                                                            numberOfPallets,
                                                            choosedValue
                                                        )
                                                    }
                                                    showSpinner={awaitingResponse}
                                                    disabled={noProduct}
                                                    isAvailableToBuy={isAvailableToBuy}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {showPrices && (
                                <div className={S.deliveryLink}>
                                    <DA_ButtonLink
                                        title={deliveryLinkText}
                                        onClick={
                                            isMobileOrTablet
                                                ? openDynamicOverlay
                                                : openShippingInfoModal
                                        }
                                    />
                                </div>
                            )}
                        </>
                    ) : null}

                    {!isAvailableToBuy ? (
                        <div className={S.priceContainer}>
                            <DA_Button
                                href={redirectUrl}
                                title={getDictionaryString("contact your dealer")}
                                icon={DA_IconNames.Pin}
                                fullWidth
                            />
                        </div>
                    ) : null}

                    {props.hazardDetails && (
                        <div className={S.hazardStatements}>
                            {props.hazardDetails.signalWords && (
                                <DA_Text bold noPadding>
                                    {props.hazardDetails.signalWords.join(", ")}
                                </DA_Text>
                            )}
                            {props.hazardDetails.hazardStatements && (
                                <ul className={S.hTextItems}>
                                    {props.hazardDetails.hazardStatements.map((text, index) => (
                                        <li key={index}>{text}</li>
                                    ))}
                                </ul>
                            )}
                            {props.hazardDetails.safetyDatasheetUrls &&
                                props.hazardDetails.safetyDatasheetUrls.map((item, index) => (
                                    <DA_InlineLink
                                        key={index}
                                        title={getDictionaryString("safetyDocument")}
                                        href={item}
                                        target="_blank"
                                    />
                                ))}
                            {props.hazardDetails.supplementalInformation && (
                                <div className={S.supplementalInformation}>
                                    {props.hazardDetails.supplementalInformation.map(
                                        (text, index) => (
                                            <DA_Text bold noPadding key={index}>
                                                {text}
                                            </DA_Text>
                                        )
                                    )}
                                </div>
                            )}
                            {props.hazardDetails.pictogramUrls && (
                                <div className={S.hazardPictograms}>
                                    {props.hazardDetails.pictogramUrls.map((pictogram, index) => (
                                        <DA_Image
                                            className={S.hazardPictogramImage}
                                            key={index}
                                            src={pictogram}
                                            alt=""
                                            role="presentation"
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div>
                {isMobileOrTablet ? (
                    extraInfoItems.map((item, index) => (
                        <DA_Accordion
                            key={index}
                            showSmallHeader
                            title={item.title}
                            showToggleIcons
                            className={S.extraInfoAccordion}
                            animation
                            ref={
                                item.title === getDictionaryString("description")
                                    ? descriptionAccordionRef
                                    : null
                            }
                        >
                            {item.content}
                        </DA_Accordion>
                    ))
                ) : (
                    <DA_Tab items={extraInfoItems} ref={tabRef} isQuickOrder={props.isQuickOrder} />
                )}
            </div>

            {/* Related products are disabled for now */}
            {/* <div>
                {props.useRelewiseRelatedProducts && relatedProducts && (
                    <div className={S.relatedProducts}>
                        <ComponentErrorBoundary showNothing componentName="RelatedProductsSlider">
                            <DA_ProductItemSlider
                                title={getDictionaryString("PdpRelatedProductsTitle")}
                                items={relatedProducts?.map((product) => mapProduct(product))}
                            />
                        </ComponentErrorBoundary>
                    </div>
                )}
            </div> */}
        </>
    );
};
